/**
 * Decodes HTML entities from strings (e.g. &amp;, &quot;, &#39;, &#8211;, &lt;, &gt;, etc.)
 * Safe for both browser and SSR / non-DOM environments.
 */
export function decodeEntities(input: string | null | undefined): string {
  if (!input) return "";

  // If we're in a browser environment with DOM access
  if (typeof document !== "undefined") {
    try {
      const textarea = document.createElement("textarea");
      textarea.innerHTML = input;
      return textarea.value;
    } catch {
      // Fallback if DOM manipulation fails
    }
  }

  // Fallback string replacement for common and numeric HTML entities
  return input
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;|&apos;/g, "'")
    .replace(/&#8211;/g, "–")
    .replace(/&#8212;/g, "—")
    .replace(/&#8216;/g, "‘")
    .replace(/&#8217;/g, "’")
    .replace(/&#8220;/g, "“")
    .replace(/&#8221;/g, "”")
    .replace(/&#(\d+);/g, (_, dec) => {
      try {
        return String.fromCharCode(parseInt(dec, 10));
      } catch {
        return _;
      }
    })
    .replace(/&#x([0-9a-f]+);/gi, (_, hex) => {
      try {
        return String.fromCharCode(parseInt(hex, 16));
      } catch {
        return _;
      }
    });
}
